import React, { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { RiCalendarScheduleLine } from "react-icons/ri";
import { RxComponentBoolean } from "react-icons/rx";
import { VscTypeHierarchySub } from "react-icons/vsc";

export default function SelectBox({
  value,
  onChange,
  optionsArray,
  condition,
  isArrayBig,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleOptionClick = (optionValue) => {
    onChange({ target: { value: optionValue } });
    setIsDropdownOpen(false);
  };

  // console.log(value);
  // console.log(optionsArray);
  const renderDataTypeIcons = (dataType) => {
    let displayContent;
    switch (dataType) {
      case "String":
        displayContent = <span className=" text-blue-950">abc</span>;
        break;
      case "Number":
        displayContent = <span className="text-[rgb(90,193,137)]">#</span>;
        break;
      case "Date":
        displayContent = <RiCalendarScheduleLine className=" text-blue-950" />;
        break;
      case "Hierarchy":
        displayContent = <VscTypeHierarchySub className=" text-blue-950" />;
        break;
      case "Boolean":
        displayContent = <RxComponentBoolean className=" text-blue-950" />;
        break;
      default:
        displayContent = "";
    }
    return displayContent;
  };

  return (
    <section className="flex items-center justify-center w-full relative">
      <div
        className="border rounded border-gray-200 pr-6 pl-1 py-1 h-[33px] w-full select-custom cursor-pointer truncate"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        {value
          ? optionsArray.find((option) =>
            condition === "conditionalFormatting"
              ? `${option.measure.value}_${option.rename}` === value
              : option.value === value
          )?.label
          : "Select an option"}
      </div>
      <span
        className="absolute top-1/2 transform -translate-y-1/2 right-2 cursor-pointer"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        {isDropdownOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
      </span>
      {isDropdownOpen && (
        <ul
          className={`absolute top-full left-0 right-0 bg-white border rounded shadow-md mt-1 z-30 overflow-y-auto ${isArrayBig ? "h-[12.5rem]" : "h-auto"
            }`}
        >
          {optionsArray.map((option, index) => (
            <li
              key={index}
              className="px-4 py-1 cursor-pointer hover:bg-gray-100 w-full flex items-center justify-start gap-2 "
              onClick={() =>
                handleOptionClick(
                  condition === "conditionalFormatting"
                    ? `${option.measure.value}_${option.rename}`
                    : option.value
                )
              }
            >
              {option?.dataType ? renderDataTypeIcons(option.dataType) : null}
              {condition === "conditionalFormatting"
                ? `${option.measure.value} (${option.rename})`
                : option.label}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
